var _path, _circle, _circle2, _g, _path2, _circle3, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 113,
    viewBox: "0 0 202 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 13C109.5 4 102.5 1.5 87 2C75 3.5 72 9.5 67.5 20C63.9 28.4 54.3333 33.5 50 35C38.5 41.5 29.5 72.4048 45.5 77.5C56.2063 80.9094 71 107.79 85 110.5C100.5 113.5 108 102.5 113.5 98C119 93.5 122.97 98.5088 136 86C148.5 74 149.502 45.3972 137 35.5C125 26 123.5 22 116.5 13Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 59.5,
    r: 21.5,
    fill: "#E8B93F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_29",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 38,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.011,
    cy: 59.9891,
    r: 21.0326,
    fill: "#E8B93F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_29)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.6957,
    cy: 51.6739,
    r: 20.5435,
    fill: "#FADF86"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 22.5C121 19 119.189 16.1581 117 13.5C110 5 102.5 1.5 87 2C75 3.5 72 9.5 67.5 20C63.9 28.4 54.3333 33.5 50 35C38.5 41.5 28.6635 71.0339 43.5 76.5C49.2763 78.6281 53.1985 82.59 58.5 88.5M129 28C134.5 32.5 137.903 37.5546 140 41C147 52.5 147.5 73 136 85C123.503 98.0408 119.5 93.5 114 98C108.5 102.5 95.6209 116.06 81.5 109C74.0522 105.276 68.2359 99.4612 63 93.7149",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 59.5,
    r: 21,
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60C87.8333 57.1667 88.6 50.9 93 48.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 88V70H0.5V57.5L33.5 11.5H47.5V57.5H58V70H47.5V88H33.5ZM13 57.5L33 31L33.5 57.5H13Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177 88V70H144V57.5L177 11.5H191V57.5H201.5V70H191V88H177ZM156.5 57.5L176.5 31L177 57.5H156.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error-404.98a7ac95ffb44c412f1cd6388dfaed51.svg";
export { ForwardRef as ReactComponent };